var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.meta.layout !== 'blank')?_c('div',{staticClass:"app"},[_vm._m(0),_c('main',[_c('router-view')],1),_vm._m(1)]):_c('router-view')
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h1',[_vm._v("我的 Vue 应用")])])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_c('p',[_vm._v("© 2024 我的应用")])])
}]

export { render, staticRenderFns }